export default {
    dieCutters: [],
    ownershipTypes: [],
    dieCuttersLoading: false,
    cancelToken: null,
    filters: setInitialFilters(),
    setInitialFilters: setInitialFilters
}

function setInitialFilters() {
    return {
        symbol: null
    }
}